import { IServices } from "@netent/origin";
import { Store } from "redux";
import { IStoreAction, IStoreState } from "../../store";
import { PlayUIListenerCreator } from "../../types";

export const onBetDenominationChangeRequest: PlayUIListenerCreator = (
  services: IServices,
  store: Store<IStoreState, IStoreAction>
) => (denomination: number) => {
  services.bet.setDenomination(denomination);
};
